import { useToast } from "../hooks/use-toast"
import { createPortal } from "react-dom"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./toast"

export function Toaster() {
  const { toasts } = useToast()
  let feedbackHost = document.querySelector('[data-wt-feedback-host]')

  if (!feedbackHost) {
    feedbackHost = document.createElement('div')
    feedbackHost.dataset.wtFeedbackHost = 'true'
    document.body.appendChild(feedbackHost)
  }

  return createPortal(
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>,
    feedbackHost
  );
}
